/** Whole-unit activity display (kWh, therms). */
export function formatActivityUnits(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return Math.round(value).toLocaleString();
}

/** MT CO2e — limited precision for headlines/tooltips. */
export function formatMtCo2e(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '—';
  if (Math.abs(value) >= 100) return Math.round(value).toLocaleString();
  return value.toLocaleString(undefined, { maximumFractionDigits: 1, minimumFractionDigits: 0 });
}

export function formatNullableActivity(value: number | null | undefined): string {
  if (value == null) return 'null';
  if (!Number.isFinite(value)) return '—';
  return formatActivityUnits(value);
}
